import { openSubnav } from './desktop-nav';

const setFocusToNextMenuItem = ($item) => {
  // ul > li > a
  const total_items_in_element = $item.parent().parent().find('.level-1-option').length;
  const element_index = $item.parent().index();

  // console.log('total_items_in_element', total_items_in_element);
  // console.log('element_index', element_index);

  if (element_index + 1 < total_items_in_element) {
    $item.parent().parent().find('.level-1-option').eq(element_index + 1).find('[data-desktop-nav-a]').trigger('focus');
  }
};

const setFocusToPreviousMenuItem = ($item) => {
  // ul > li > a
  const element_index = $item.parent().index();

  if (element_index - 1 >= 0) {
    $item.parent().parent().find('.level-1-option').eq(element_index - 1).find('[data-desktop-nav-a]').trigger('focus');
  }
};

const setFocusToFirstSubMenuItem = ($item) => {
  if ($item.parent().find('[role="menuitem"]').length === 0) {
    return;
  }

  $item.parent().find('[role="menuitem"]').first().trigger('focus');
};

const setFocusToNextSubMenuItem = ($item) => {
  const total_items_in_element = $item.closest('.nav__level-2').find('[role="menuitem"]').length;
  // data-menuitem-index starts at 1
  const element_index = $item.data('menuitem-index');
  // console.log('total_items_in_element', total_items_in_element);
  // console.log('element_index', element_index);

  if (element_index + 1 < total_items_in_element + 1) {
    $item.closest('.nav__level-2').find(`[role="menuitem"][data-menuitem-index="${element_index + 1}"]`).trigger('focus');
  } else {
    // go to next menu item
    setFocusToNextMenuItem($item.closest('.level-1-option').find('[data-desktop-nav-a]'));
  }
};

const setFocusToPreviousSubMenuItem = ($item) => {
  const element_index = $item.data('menuitem-index');

  if (element_index - 1 >= 1) {
    $item.closest('.nav__level-2').find(`[role="menuitem"][data-menuitem-index="${element_index - 1}"]`).trigger('focus');
  } else {
    // go to previous menu item
    setFocusToPreviousMenuItem($item.closest('.level-1-option').find('[data-desktop-nav-a]'));
  }
};

const initDesktopNavArrowsNavigation = () => {
  // Select a level 1 menu item
  // keypress doesn't work for the arrow keys for some reasons
  $(document).on('keydown', '[data-desktop-nav-a]', (e) => {
    const $item = $(e.currentTarget);
    const key = e.which;
    // console.log('key', key, $(':focus'));

    switch (key) {
      // left
      case 37:
        setFocusToPreviousMenuItem($item);
        break;

      // right
      case 39:
        setFocusToNextMenuItem($item);
        break;

      // down
      case 40:
        setFocusToFirstSubMenuItem($item);
        break;
    }
  });

  // Select a subnav menu item
  $(document).on('keydown', '[data-has-subnav="true"] [role="menuitem"]', (e) => {
    const $item = $(e.currentTarget);
    const key = e.which;

    switch (key) {
      // left
      case 37:
        setFocusToPreviousSubMenuItem($item);
        break;

      // right
      case 39:
        setFocusToNextSubMenuItem($item);
        break;

      // down
      case 40:
        setFocusToNextSubMenuItem($item);
        break;

      // up
      case 38:
        setFocusToPreviousSubMenuItem($item);
        break;
    }
  });

  // [ADA] Go back to nav after leaving a subnav with space button
  // $(document).on('keypress', (e) => {
  //   if ($('[data-has-subnav="true"].opened').length === 0) {
  //     return;
  //   }

  //   const key = e.which;
  //   console.log('key', key);
  
  //   // Space
  //   if (key === 32) {
  //     const $item = $('[data-has-subnav="true"].opened').first();
  //     $(`[data-main-nav] [data-has-children][data-handle="${$item.data('parent')}"]`).trigger('focus');
  //   }
  // });
};

const setFocusToPreviousPreHeaderItem = ($item) => {
  const element_index = $item.parent().index();
  
  if (element_index > 0) {
    $($('#preheaderMenu li')[element_index - 1]).find('[role="menuitem"]').trigger('focus');
  }
};

const setFocusToNextPreHeaderItem = ($item) => {
  const element_index = $item.parent().index();
  
  if (element_index < $('#preheaderMenu li').length - 1) {
    $($('#preheaderMenu li')[element_index + 1]).find('[role="menuitem"]').trigger('focus');
  } else {
    $('.main-nav--desktop .logo__image').trigger('focus');
  }
};

const initDesktopPreHeaderArrowsNavigation = () => {
  $(document).on('keydown', '[data-preheader] [role="menuitem"]', (e) => {
    const $item = $(e.currentTarget);
    const key = e.which;
    // console.log('key', key, $(':focus'));

    switch (key) {
      // left
      case 37:
        setFocusToPreviousPreHeaderItem($item);
        break;

      // right
      case 39:
        setFocusToNextPreHeaderItem($item);
        break;

      // Enter / spacebar
      case 13:
      case 32:
        $item.trigger('click');
        break;
    }
  });
};

export default () => {
  // // Close button added by ADA app
  // $(document).on('click', '#accountNav .INDdialogClose', () => {
  //   $('[data-parent="account"]').removeClass('opened').removeClass('keep-opened');
  //   $('[data-handle="account"] a').attr('aria-expanded', false);
  // });

  $(document).on('focusin', '.main-nav--desktop .nav__level-1 li [data-desktop-nav-a]', (e) => {
    const $item = $(e.currentTarget);
    const handle = $item.parent().data('handle');

    if (handle === 'account') {
      return;
    }

    // $item.parent().addClass('hover');
    console.log('focus in nav item', handle);

    // $item.parent().trigger('mouseenter');
    openSubnav($item.parent());
    $item.attr('aria-expanded', true);

    $(`[data-main-nav] [data-parent="${$item.data('handle')}"] [role="menuitem"]`).first().trigger('focus');
  });

  $(document).on('focusout', '.main-nav--desktop .nav__level-1 li [data-desktop-nav-a]', (e) => {    
    const $item = $(e.currentTarget);
    const handle = $item.parent().data('handle');

    if (handle === 'account') {
      return;
    }

    console.log('focus out nav item', $item.parent().data('handle'), $(`[data-main-nav] [data-parent="${handle}"]`).hasClass('opened'));

    // Update aria-expanded, this also forces it to keep true if using down arrow
    $item.attr('aria-expanded', $(`[data-main-nav] [data-parent="${handle}"]`).hasClass('opened'));

    if (!$(`[data-main-nav] [data-parent="${handle}"]`).hasClass('opened')) {
      // $item.parent().removeClass('hover');
      $item.parent().trigger('mouseleave');
    }
  });

  $(document).on('keypress', '#accountNav', (e) => {
    const key = e.which;
  
    // Escape
    if (key === 27) {
      if ($('#accountNav').hasClass('keep-opened')) {
        $('[data-account-nav]').trigger('click');
        $('[data-cart-nav]').trigger('focus');
      }
    }
  });

  $(document).on('focusin', '[data-cart-nav]', () => {
    $('#accountNav').removeClass('keep-opened');
  });

  $(document).on('focusin', '[data-wishlist-nav]', () => {
    $('#accountNav').removeClass('keep-opened');
  });

  initDesktopPreHeaderArrowsNavigation();
  initDesktopNavArrowsNavigation();
};
